export default __webpack_public_path__ + "static/media/astro-1.d4c2cc56.png";